import { render } from "./bulk-customers-upload.vue?vue&type=template&id=0a25fa06"
import script from "./bulk-customers-upload.vue?vue&type=script&lang=js"
export * from "./bulk-customers-upload.vue?vue&type=script&lang=js"

import "./bulk-customers-upload.vue?vue&type=style&index=0&id=0a25fa06&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__